import { render } from "./Donut.vue?vue&type=template&id=a87fe688"
import script from "./Donut.vue?vue&type=script&setup=true&lang=js"
export * from "./Donut.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "/var/www/redontrack/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/common/donut/Donut.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "a87fe688"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('a87fe688', __exports__)) {
    console.log('reload')
    api.reload('a87fe688', __exports__)
  }
  
  module.hot.accept("./Donut.vue?vue&type=template&id=a87fe688", () => {
    console.log('re-render')
    api.rerender('a87fe688', render)
  })

}


export default __exports__